import { render, staticRenderFns } from "./CreditReportReportView.vue?vue&type=template&id=b2f7c87a&"
import script from "./CreditReportReportView.vue?vue&type=script&lang=js&"
export * from "./CreditReportReportView.vue?vue&type=script&lang=js&"
import style0 from "./CreditReportReportView.vue?vue&type=style&index=0&id=b2f7c87a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports